import React from "react";

export const NotFound: React.FC = () => {
  return (
    <div className="h-[600px] flex justify-center items-center">
      <h1 className="text-red-700">No Data found!</h1>
    </div>
  );
};
